<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div>

                <button mat-raised-button color="primary" (click)="openRequestCreateModal()">
                    <mat-icon class="mdc-button__icon">add</mat-icon>
                    <span class="mdc-button__label">Yeni Talep
                        Oluştur</span>
                </button>
            </div>

            <mat-tab-group [selectedIndex]="selectedTab">
                <!-- Temporarily remove *ngIf for testing -->
                <mat-tab label="Taleplerim">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İstek Sınıfı Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedReqClassDescription">
                                        <!--<mat-select [(value)]="selectedReqClassDescription" (selectionChange)="reqClassChanged(0)">-->
                                        <mat-option *ngFor="let reqClass of reqClassList"
                                            [value]="reqClass.description">
                                            {{reqClass.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' +
                                            department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input matInput [matDatepicker]="pickerStart1" [formControl]="startDateFilterValue1"
                                        style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart1"></mat-datepicker-toggle>
                                    <!--<mat-datepicker startView="multi-year"
                                                    (yearSelected)="chosenYearHandler($event, 0)"
                                                    (monthSelected)="chosenMonthHandler($event, pickerStart1, 0)"
                                                    #pickerStart1></mat-datepicker>-->
                                    <mat-datepicker startView="multi-year" #pickerStart1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd1"
                                        [formControl]="endDateFilterValue1">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd1"></mat-datepicker-toggle>
                                    <!--<mat-datepicker #pickerEnd1
                                                    startView="multi-year"
                                                    (yearSelected)="chosenYear2Handler($event, 0)"
                                                    (monthSelected)="chosenMonth2Handler($event, pickerEnd1, 0)"></mat-datepicker>-->
                                    <mat-datepicker #pickerEnd1 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn"
                                    (click)="filterGrid(0, 'TALEPLERIM', startDateFilterValue1, endDateFilterValue1)"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(0, 'TALEPLERIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="exporter1.exportTable('xlsx', {fileName:'taleplerim', sheet: 'sayfa1'})">
                                    Excel'e Aktar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Arama</mat-label>
                                    <input matInput (keyup)="applyFilter1($event)" placeholder="">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-table matTableExporter [hiddenColumns]="[0,8]" #exporter1="matTableExporter"
                            class="lessons-table mat-elevation-z8" [dataSource]="dsMyRequest">

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    [ngStyle]="{'color' : element.approveStatus == 'ONAYLANDI' ? 'green' :
                                                                element.approveStatus == 'REDDEDİLDİ' ? 'red' : 'gray'}">
                                    {{element.approveStatus == 'AÇIK' ? 'Açık' :
                                    element.approveStatus == 'DEVAM EDİYOR' ? 'Devam Ediyor' :
                                    element.approveStatus == 'ONAYLANDI' ? 'Onaylandı' :
                                    element.approveStatus == 'REDDEDİLDİ' ? 'Reddedildi' : ' '}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqClass">
                                <mat-header-cell *matHeaderCellDef>Talep Sınıfı</mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqClass}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqType">
                                <mat-header-cell *matHeaderCellDef> Talep Tipi </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqType}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="subject">
                                <mat-header-cell *matHeaderCellDef> Başlık </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.subject}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef> Kayıt Tarihi </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.createdAt | date: 'dd.MM.yyyy
                                        HH:mm'}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-header-cell">
                                    <mat-icon class="settings-icon" aria-label="settings">settings</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <button mat-icon-button matTooltip="Güncelle"
                                        class="action-button modern-icon-button" (click)="openUpdateModal(element)">
                                        <mat-icon class="modern-icon">edit</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row style="cursor: pointer;" *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>

                        <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" [pageSize]="20"
                            #myRequestPaginator="matPaginator" showFirstLastButtons></mat-paginator>

                    </div>
                </mat-tab>
                <mat-tab label="Onayda Bekleyenler" *ngIf="currentUser.manager">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İstek Sınıfı Seçiniz</mat-label>
                                    <!-- <mat-select [(value)]="selectedReqClassDescription" (selectionChange)="reqClassChanged(1)"> -->
                                    <mat-select [(value)]="selectedReqClassDescription">
                                        <mat-option *ngFor="let reqClass of reqClassList"
                                            [value]="reqClass.description">
                                            {{reqClass.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' +
                                            department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart2"
                                        [formControl]="startDateFilterValue2" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart2"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd2"
                                        [formControl]="endDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd2 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn"
                                    (click)="filterGrid(1, 'ONAYDA_BEKLEYENLER', startDateFilterValue2, endDateFilterValue2)"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link"
                                    (click)="clearfilterGrid(1, 'ONAYDA_BEKLEYENLER')"
                                    style="margin-right: 5px;">Temizle</button>

                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="exporter2.exportTable('xlsx', {fileName:'onay_bekleyenler', sheet: 'sayfa1'})">
                                    Excel'e Aktar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Arama</mat-label>
                                    <input matInput (keyup)="applyFilter2($event)" placeholder="">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-table matTableExporter #exporter2="matTableExporter" [hiddenColumns]="[0,8]"
                            class="lessons-table mat-elevation-z8" [dataSource]="dsWaitings">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="table-checkbox">
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" class="table-checkbox">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    [ngStyle]="{'color' : element.approveStatus == 'ONAYLANDI' ? 'green' :
                                                                element.approveStatus == 'REDDEDİLDİ' ? 'red' : 'gray'}">
                                    {{element.approveStatus == 'AÇIK' ? 'Açık' :
                                    element.approveStatus == 'DEVAM EDİYOR' ? 'Devam Ediyor' :
                                    element.approveStatus == 'ONAYLANDI' ? 'Onaylandı' :
                                    element.approveStatus == 'REDDEDİLDİ' ? 'Reddedildi' : ' '}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqClass">
                                <mat-header-cell *matHeaderCellDef> Talep Sınıfı </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqClass}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqType">
                                <mat-header-cell *matHeaderCellDef> Talep Tipi </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqType}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="subject">
                                <mat-header-cell *matHeaderCellDef> Başlık </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.subject}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef> Kayıt Tarihi </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.createdAt | date: 'dd.MM.yyyy
                                        HH:mm'}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell"
                                    style="flex-grow: 1 !important;">
                                    <button mat-icon-button matTooltip="Detay"
                                        class="request-iconbutton iconbutton action-edit-button"
                                        (click)="openDetail(element)">
                                        <mat-icon class="absence-action-icon"
                                            aria-label="Detail">insert_comment</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Onayla"
                                        class="request-iconbutton iconbutton action-edit-button"
                                        (click)="openApproveModal(element)">
                                        <mat-icon class="request-action-icon" aria-label="Edit">done_outline</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Reddet"
                                        class="request-iconbutton iconbutton action-delete-button"
                                        (click)="openRejectModal(element)">
                                        <mat-icon class="request-action-icon"
                                            aria-label="delete">highlight_off</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="checkboxDisplayedColumns"></mat-header-row>
                            <mat-row style="cursor: pointer;"
                                *matRowDef="let row; columns: checkboxDisplayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" #waitingsPaginator="matPaginator"
                            showFirstLastButtons></mat-paginator>
                        <div class="col-lg-3" style="margin-top: 5px;margin-bottom: auto;padding-left: 0 !important;">
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="warn"
                                (click)="openRejectSelectedModal()" style="margin-right: 5px;">Reddet</button>
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="primary"
                                (click)="openApproveSelectedModal()" style="margin-right: 5px;">Onayla</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="İşlemde Olanlar" *ngIf="currentUser.manager">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İstek Sınıfı Seçiniz</mat-label>
                                    <!-- <mat-select [(value)]="selectedReqClassDescription" (selectionChange)="reqClassChanged(1)"> -->
                                    <mat-select [(value)]="selectedReqClassDescription">
                                        <mat-option *ngFor="let reqClass of reqClassList"
                                            [value]="reqClass.description">
                                            {{reqClass.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' +
                                            department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart2"
                                        [formControl]="startDateFilterValue2" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart2"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd2"
                                        [formControl]="endDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd2 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn"
                                    (click)="filterGrid(2, 'IŞLEMDE_OLANLAR', startDateFilterValue2, endDateFilterValue2)"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(2, 'IŞLEMDE_OLANLAR')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="exporter2.exportTable('xlsx', {fileName:'işlemde_olanlar', sheet: 'sayfa1'})">
                                    Excel'e Aktar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Arama</mat-label>
                                    <input matInput (keyup)="applyFilter3($event)" placeholder="">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-table matTableExporter #exporter2="matTableExporter" [hiddenColumns]="[0,8]"
                            class="lessons-table mat-elevation-z8" [dataSource]="dsProcess">

                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="table-checkbox">
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" class="table-checkbox">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    [ngStyle]="{'color' : element.approveStatus == 'ONAYLANDI' ? 'green' :
                                                                element.approveStatus == 'REDDEDİLDİ' ? 'red' : 'gray'}">
                                    {{element.approveStatus == 'AÇIK' ? 'Açık' :
                                    element.approveStatus == 'DEVAM EDİYOR' ? 'Devam Ediyor' :
                                    element.approveStatus == 'ONAYLANDI' ? 'Onaylandı' :
                                    element.approveStatus == 'REDDEDİLDİ' ? 'Reddedildi' : ' '}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqClass">
                                <mat-header-cell *matHeaderCellDef> Talep Sınıfı </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqClass}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqType">
                                <mat-header-cell *matHeaderCellDef> Talep Tipi </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqType}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="subject">
                                <mat-header-cell *matHeaderCellDef> Başlık </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.subject}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef> Kayıt Tarihi </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.createdAt | date: 'dd.MM.yyyy
                                        HH:mm'}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell"
                                    style="flex-grow: 1 !important;">
                                    <button mat-icon-button matTooltip="Detay"
                                        class="request-iconbutton iconbutton action-edit-button"
                                        (click)="openDetail(element)">
                                        <mat-icon class="absence-action-icon"
                                            aria-label="Detail">insert_comment</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Tamamlandı"
                                        class="request-iconbutton iconbutton action-edit-button"
                                        (click)="openCompleteModal(element)">
                                        <mat-icon class="request-action-icon" aria-label="Edit">done_outline</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="İptal"
                                        class="request-iconbutton iconbutton action-delete-button"
                                        (click)="openCancelModal(element)">
                                        <mat-icon class="request-action-icon"
                                            aria-label="delete">highlight_off</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="checkboxDisplayedColumns"></mat-header-row>
                            <mat-row style="cursor: pointer;"
                                *matRowDef="let row; columns: checkboxDisplayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" #processPaginator="matPaginator"
                            showFirstLastButtons></mat-paginator>
                        <div class="col-lg-3" style="margin-top: 5px;margin-bottom: auto;padding-left: 0 !important;">
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="warn"
                                (click)="openCancelSelectedModal()" style="margin-right: 5px;">İptal</button>
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="primary"
                                (click)="opencompleteSelectedModal()" style="margin-right: 5px;">Tamamlandı</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Sonuçlananlar" *ngIf="currentUser.manager">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İstek Sınıfı Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedReqClassDescription"
                                        (selectionChange)="reqClassChanged(2)">
                                        <mat-option *ngFor="let reqClass of reqClassList"
                                            [value]="reqClass.description">
                                            {{reqClass.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' +
                                            department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart3"
                                        [formControl]="startDateFilterValue3" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart3"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart3></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd3"
                                        [formControl]="endDateFilterValue3">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd3"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd3 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn"
                                    (click)="filterGrid(3, 'SONUCLANANLAR', startDateFilterValue3, endDateFilterValue3)"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(3, 'SONUCLANANLAR')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="exporter3.exportTable('xlsx', {fileName:'sonuçlananlar', sheet: 'sayfa1'})">
                                    Excel'e Aktar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Arama</mat-label>
                                    <input matInput (keyup)="applyFilter4($event)" placeholder="">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-table matTableExporter #exporter3="matTableExporter" [hiddenColumns]="[0,8]"
                            class="lessons-table mat-elevation-z8" [dataSource]="dsMyResult">

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    [ngStyle]="{'color' : element.processStatus == 'TAMAMLANDI' ? 'green' :
                                                                element.processStatus == 'İPTAL EDİLDİ' ? 'red' : ' '}">
                                    {{element.processStatus == 'TAMAMLANDI' ? 'Tamamlandı' :
                                    element.processStatus == 'İPTAL EDİLDİ' ? 'İptal Edildi' :
                                    ' '}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqClass">
                                <mat-header-cell *matHeaderCellDef> Talep Sınıfı </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqClass}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqType">
                                <mat-header-cell *matHeaderCellDef> Talep Tipi </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqType}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="subject">
                                <mat-header-cell *matHeaderCellDef> Başlık </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.subject}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef> Kayıt Tarihi </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.createdAt | date: 'dd.MM.yyyy
                                        HH:mm'}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <button mat-icon-button matTooltip="Detay"
                                        class="absence-iconbutton iconbutton action-edit-button"
                                        (click)="openDetail(element)">
                                        <mat-icon class="absence-action-icon"
                                            aria-label="Detail">insert_comment</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" #resultPaginator="matPaginator"
                            showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Tüm Talepler" *ngIf="currentUser.manager">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İstek Sınıfı Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedReqClassDescription"
                                        (selectionChange)="reqClassChanged(3)">
                                        <mat-option *ngFor="let reqClass of reqClassList"
                                            [value]="reqClass.description">
                                            {{reqClass.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' +
                                            department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart4"
                                        [formControl]="startDateFilterValue4" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart4"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart4></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd4"
                                        [formControl]="endDateFilterValue4">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd4"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd4 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-4">
                                <button mat-raised-button color="warn"
                                    (click)="filterGrid(4, 'TÜM TALEPLER', startDateFilterValue4, endDateFilterValue4)"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(4, 'TÜM TALEPLER')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="exporter4.exportTable('xlsx', {fileName:'tüm_talepler', sheet: 'sayfa1'})">
                                    Excel'e Aktar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Arama</mat-label>
                                    <input matInput (keyup)="applyFilter5($event)" placeholder="">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-table matTableExporter #exporter4="matTableExporter" [hiddenColumns]="[0,8]"
                            class="lessons-table mat-elevation-z8" [dataSource]="dsAllRequest">

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    [ngStyle]="{'color' : element.processStatus == 'TAMAMLANDI' ? 'green' :
                                                                element.processStatus == 'İPTAL EDİLDİ' ? 'red' :
                                                                element.approveStatus == 'ONAYLANDI' ? 'green' :
                                                                element.approveStatus == 'REDDEDİLDİ' ? 'red' : 'gray'}">
                                    {{element.processStatus == 'TAMAMLANDI' ? 'Tamamlandı' :
                                    element.processStatus == 'İPTAL EDİLDİ' ? 'İptal Edildi' :
                                    element.approveStatus == 'ONAYLANDI' ? 'Onaylandı' :
                                    element.approveStatus == 'REDDEDİLDİ' ? 'Reddedildi' :
                                    element.approveStatus == 'AÇIK' ? 'Açık' :
                                    element.approveStatus == 'DEVAM EDİYOR' ? 'Devam Ediyor' :' '}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqClass">
                                <mat-header-cell *matHeaderCellDef> Talep Sınıfı </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqClass}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="reqType">
                                <mat-header-cell *matHeaderCellDef> Talep Tipi </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.reqType}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="subject">
                                <mat-header-cell *matHeaderCellDef> Başlık </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.subject}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef> Kayıt Tarihi </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.createdAt | date: 'dd.MM.yyyy
                                        HH:mm'}}</span></mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <button mat-icon-button matTooltip="Detay"
                                        class="absence-iconbutton iconbutton action-edit-button"
                                        (click)="openDetail(element)">
                                        <mat-icon class="absence-action-icon"
                                            aria-label="Detail">insert_comment</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row style="cursor: pointer;" *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" #allRequestPaginator="matPaginator"
                            showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>